// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GetSiteAccountsResponseModel } from './getSiteAccountsResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteAccountV2SiteAccountSiteAccountsByPortalIdResponse {
    'data': GetSiteAccountsResponseModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteAccountV2SiteAccountSiteAccountsByPortalIdResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "GetSiteAccountsResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return SiteAccountV2SiteAccountSiteAccountsByPortalIdResponse.attributeTypeMap;
    }
}
